export const getFormState = (fields) => {
	return fields.reduce((a, e) => {
		if (e.type == "group") {
			for (const el of e.items) {
				a[el.name] = el.defaultValue || (el.multiple ? [] : "");
			}
		} else if (e.type == "fields") {
			const state = getFormState(e.items);
			a[e.name] = e.defaultValue || (e.multiple ? [state] : { ...state });
		} else {
			a[e.name] = e.defaultValue || (e.multiple ? [] : e.type=="switch"?false:"");
		}
		return a;
	}, {});
};

export const parseSavedData = (data, fields) => {
	for (const e of fields) {
		if (e.type != "group" && e.parse) {
			data[e.name] = e.parse(data[e.name]);
		} else if (e.type == "group") {
			for (const el of e.items) {
				if (el.parse) {
					data[el.name] = el.parse(data[el.name]);
				}
			}
		}
	}
	return data;
};
